import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconEnhance: React.FC<IconProps> = ({ width = 21, height = 21, color = 'black' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 21 20"
            fill="none"
        >
            <g clip-path="url(#clip0_10714_1026)">
                <path
                    d="M17.7395 13.6044C17.6882 13.3589 17.4862 13.1694 17.2368 13.1374C16.9885 13.1055 16.7427 13.2438 16.6356 13.4686C16.5294 13.6917 16.5791 13.9646 16.7549 14.1377C16.9148 14.2951 17.1594 14.346 17.3691 14.2678C17.6373 14.1677 17.792 13.8842 17.7395 13.6044Z"
                    fill="white"
                />
                <path
                    d="M15.4598 16.1522C15.4149 15.9119 15.2118 15.7231 14.9717 15.687C14.7297 15.6505 14.484 15.7747 14.3688 15.9904C14.2538 16.2058 14.2868 16.4789 14.4512 16.6599C14.6157 16.8411 14.8834 16.901 15.1094 16.8076C15.3622 16.7032 15.5173 16.4218 15.4598 16.1522Z"
                    fill="white"
                />
                <path
                    d="M19.331 18.207C19.286 17.991 19.1172 17.8131 18.9044 17.7556C18.6886 17.6974 18.4565 17.7742 18.3119 17.9431C18.1589 18.122 18.1283 18.3768 18.2348 18.587C18.3637 18.8416 18.669 18.9677 18.9402 18.8777C19.2152 18.7864 19.3906 18.4925 19.331 18.207Z"
                    fill="white"
                />
                <path
                    d="M19.1285 9.54693C18.924 9.38552 18.6353 9.36927 18.4199 9.52107C18.2172 9.66404 18.1248 9.92782 18.1953 10.1658C18.2644 10.3989 18.4774 10.5704 18.7209 10.585C18.9678 10.5997 19.2037 10.4529 19.2981 10.2243C19.3965 9.98599 19.3243 9.712 19.1285 9.54693Z"
                    fill="white"
                />
                <path
                    d="M14.3975 12.4141C14.6415 12.4389 14.8795 12.3016 14.9846 12.0812C15.0897 11.861 15.0422 11.5886 14.8694 11.4165C14.6959 11.2437 14.4261 11.1967 14.2048 11.3015C13.9841 11.406 13.8471 11.645 13.8721 11.8887C13.9003 12.1636 14.1223 12.3862 14.3975 12.4141Z"
                    fill="white"
                />
                <path
                    d="M20.5458 5.31934L19.2288 3.55454L19.936 1.46923C20.0076 1.25802 19.9531 1.02442 19.7954 0.866728C19.6377 0.708993 19.404 0.654423 19.1929 0.726142L17.1075 1.43329L15.3428 0.116376C15.164 -0.0170223 14.9251 -0.0374129 14.7263 0.0638762C14.5276 0.165126 14.4036 0.370439 14.4065 0.593446L14.4346 2.79528L12.6368 4.06669C12.4547 4.19548 12.3615 4.41645 12.3964 4.63677C12.4313 4.85708 12.5882 5.03841 12.8012 5.10466L14.2718 5.56177L11.1964 8.63716L11.1321 8.57282C10.9032 8.34399 10.5322 8.34399 10.3034 8.57282C10.0746 8.80161 10.0746 9.17263 10.3034 9.40145L10.3678 9.46583L0.83373 18.9998C0.604902 19.2286 0.604902 19.5996 0.83373 19.8284C0.948105 19.9428 1.09807 20 1.24803 20C1.39799 20 1.54795 19.9428 1.66232 19.8284L11.1963 10.2944L11.2606 10.3588C11.3751 10.4732 11.525 10.5304 11.6749 10.5304C11.8249 10.5304 11.9749 10.4731 12.0892 10.3588C12.3181 10.13 12.3181 9.75895 12.0892 9.53013L12.0249 9.46575L15.1003 6.39032L15.5574 7.86095C15.6236 8.07395 15.805 8.23087 16.0253 8.26575C16.056 8.27059 16.0866 8.27298 16.1171 8.27298C16.3053 8.27298 16.4845 8.18212 16.5954 8.02536L17.8668 6.22751L20.0686 6.25567C20.2916 6.25841 20.4969 6.13454 20.5982 5.93579C20.6995 5.73708 20.6792 5.49806 20.5458 5.31934ZM17.5738 5.05181C17.5713 5.05177 17.5688 5.05177 17.5663 5.05177C17.3763 5.05177 17.1979 5.14395 17.0879 5.29938L16.3242 6.37938L15.934 5.12446C15.8787 4.93602 15.7262 4.78419 15.5382 4.72821L14.2827 4.33798L15.3627 3.57419C15.5202 3.46282 15.6128 3.28114 15.6103 3.08833L15.5934 1.76563L16.6535 2.55677C16.8081 2.67208 17.0095 2.70395 17.1921 2.64208L18.4449 2.21727L18.02 3.46997C17.9581 3.65263 17.99 3.85403 18.1053 4.00856L18.8965 5.06872L17.5738 5.05181Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_10714_1026">
                    <rect width="20" height="20" fill={color} transform="translate(0.662109)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconEnhance;
